import _ from 'lodash';
import { IVehiclePaint, VehiclePaintType } from '~/shared';
import { AbstractVehiclePaintShopService } from './AbstractVehiclePaintShopService';
import { IVehiclePaintShopService } from './vehiclePaintShopServiceTypes';

export class VehiclePaintShopServiceStub
	extends AbstractVehiclePaintShopService
	implements IVehiclePaintShopService
{
	private ownedPaintStub: IVehiclePaint = {
		bodyColor: {
			color: 'ffffff',
			type: VehiclePaintType.Classic,
		},
		interiorColor: 'ffffff',
		brakesColor: 0,
	};

	constructor() {
		super();

		this.updateColors();
	}

	private brakesColorsData = [
		{
			index: 0,
			name: 'Черный',
			type: VehiclePaintType.Classic,
			hex: '#0d0d0d',
			showInPaint: false,
			showInRims: false,
			showInBrakes: true,
		},
		{
			index: 1,
			name: 'Темно-серый',
			type: VehiclePaintType.Classic,
			hex: '#404040',
			showInPaint: false,
			showInRims: false,
			showInBrakes: true,
		},
		{
			index: 2,
			name: 'Серый',
			type: VehiclePaintType.Classic,
			hex: '#808080',
			showInPaint: false,
			showInRims: false,
			showInBrakes: true,
		},
		{
			index: 3,
			name: 'Белый',
			type: VehiclePaintType.Classic,
			hex: '#ffffff',
			showInPaint: false,
			showInRims: false,
			showInBrakes: true,
		},
		{
			index: 14,
			name: 'Красный Formula',
			type: VehiclePaintType.Classic,
			hex: '#c40000',
			showInPaint: false,
			showInRims: false,
			showInBrakes: true,
		},
		{
			index: 15,
			name: 'Лавово-красный',
			type: VehiclePaintType.Classic,
			hex: '#ff4500',
			showInPaint: false,
			showInRims: false,
			showInBrakes: true,
		},
		{
			index: 16,
			name: 'Огненно-красный',
			type: VehiclePaintType.Classic,
			hex: '#ff1a1a',
			showInPaint: false,
			showInRims: false,
			showInBrakes: true,
		},
		{
			index: 23,
			name: 'Ярко-розовый',
			type: VehiclePaintType.Classic,
			hex: '#ff1493',
			showInPaint: false,
			showInRims: false,
			showInBrakes: true,
		},
		{
			index: 34,
			name: 'Темно-синий',
			type: VehiclePaintType.Classic,
			hex: '#00008b',
			showInPaint: false,
			showInRims: false,
			showInBrakes: true,
		},
		{
			index: 35,
			name: 'Синий',
			type: VehiclePaintType.Classic,
			hex: '#0000ff',
			showInPaint: false,
			showInRims: false,
			showInBrakes: true,
		},
		{
			index: 52,
			name: 'Ярко-зеленый',
			type: VehiclePaintType.Classic,
			hex: '#00ff00',
			showInPaint: false,
			showInRims: false,
			showInBrakes: true,
		},
		{
			index: 66,
			name: 'Желтый',
			type: VehiclePaintType.Classic,
			hex: '#ffff00',
			showInPaint: false,
			showInRims: false,
			showInBrakes: true,
		},
		{
			index: 88,
			name: 'Оранжевый',
			type: VehiclePaintType.Classic,
			hex: '#ff8c00',
			showInPaint: false,
			showInRims: false,
			showInBrakes: true,
		},
		{
			index: 135,
			name: 'Фиолетовый',
			type: VehiclePaintType.Classic,
			hex: '#800080',
			showInPaint: false,
			showInRims: false,
			showInBrakes: true,
		},
	];

	private updateColors() {
		const paintTypes = [
			{
				index: 0,
				name: 'Металлик',
				type: VehiclePaintType.Metallic,
				price: 10_000,
			},
			{
				index: 1,
				name: 'Обычный',
				type: VehiclePaintType.Classic,
				price: 11_000,
			},
			{
				index: 2,
				name: 'Глянцевый',
				type: VehiclePaintType.Pearl,
				price: 12_000,
			},
			{
				index: 3,
				name: 'Матовый',
				type: VehiclePaintType.Matte,
				price: 13_000,
			},
			{
				index: 4,
				name: 'Металл',
				type: VehiclePaintType.Metals,
				price: 14_000,
			},
			{ index: 5, name: 'Хром', type: VehiclePaintType.Chrome, price: 15_000 },
			{
				index: 6,
				name: 'Хамелеон',
				type: VehiclePaintType.Chameleon,
				price: 16_000,
			},
		];
		this.paintTypes.next(paintTypes);

		// Colors
		const paintColors = [
			{
				index: 0,
				name: 'Черный',
				type: VehiclePaintType.Pearl,
				hex: null,
				showInPaint: true,
				showInRims: true,
				showInBrakes: false,
			},
			{
				index: 15,
				name: 'Лавово-красный',
				type: VehiclePaintType.Pearl,
				hex: null,
				showInPaint: true,
				showInRims: true,
				showInBrakes: false,
			},
			{
				index: 16,
				name: 'Огненно-красный',
				type: VehiclePaintType.Pearl,
				hex: null,
				showInPaint: true,
				showInRims: true,
				showInBrakes: false,
			},
			{
				index: 17,
				name: 'Красный Grace',
				type: VehiclePaintType.Pearl,
				hex: null,
				showInPaint: true,
				showInRims: true,
				showInBrakes: false,
			},
			{
				index: 18,
				name: 'Гранатовый',
				type: VehiclePaintType.Pearl,
				hex: null,
				showInPaint: true,
				showInRims: true,
				showInBrakes: false,
			},
			{
				index: 19,
				name: 'Закатно-красный',
				type: VehiclePaintType.Pearl,
				hex: null,
				showInPaint: true,
				showInRims: true,
				showInBrakes: false,
			},
			{
				index: 20,
				name: 'Каберне',
				type: VehiclePaintType.Pearl,
				hex: null,
				showInPaint: true,
				showInRims: true,
				showInBrakes: false,
			},
			{
				index: 21,
				name: 'Винно-красный',
				type: VehiclePaintType.Pearl,
				hex: null,
				showInPaint: true,
				showInRims: true,
				showInBrakes: false,
			},
			{
				index: 22,
				name: 'Яблочно-красный',
				type: VehiclePaintType.Pearl,
				hex: null,
				showInPaint: true,
				showInRims: true,
				showInBrakes: false,
			},
			{
				index: 23,
				name: 'Ярко-розовый',
				type: VehiclePaintType.Pearl,
				hex: null,
				showInPaint: true,
				showInRims: true,
				showInBrakes: false,
			},
			{
				index: 24,
				name: 'Розовый Pfister',
				type: VehiclePaintType.Pearl,
				hex: null,
				showInPaint: true,
				showInRims: true,
				showInBrakes: false,
			},
			{
				index: 25,
				name: 'Лососево-розовый',
				type: VehiclePaintType.Pearl,
				hex: null,
				showInPaint: true,
				showInRims: true,
				showInBrakes: false,
			},

			{
				index: 170,
				name: 'Анод. золотой перламутр',
				type: VehiclePaintType.Chameleon,
				hex: null,
				showInPaint: true,
				showInRims: false,
				showInBrakes: false,
			},
			{
				index: 171,
				name: 'Зел./синий переливчатый',
				type: VehiclePaintType.Chameleon,
				hex: null,
				showInPaint: true,
				showInRims: false,
				showInBrakes: false,
			},
			{
				index: 172,
				name: 'Зел./красный переливчатый',
				type: VehiclePaintType.Chameleon,
				hex: null,
				showInPaint: true,
				showInRims: false,
				showInBrakes: false,
			},
			{
				index: 173,
				name: 'Зел./корич. переливчатый',
				type: VehiclePaintType.Chameleon,
				hex: null,
				showInPaint: true,
				showInRims: false,
				showInBrakes: false,
			},
			{
				index: 174,
				name: 'Зел./бирюзовый переливчатый',
				type: VehiclePaintType.Chameleon,
				hex: null,
				showInPaint: true,
				showInRims: false,
				showInBrakes: false,
			},
			{
				index: 175,
				name: 'Зел./фиол. переливчатый',
				type: VehiclePaintType.Chameleon,
				hex: null,
				showInPaint: true,
				showInRims: false,
				showInBrakes: false,
			},
			{
				index: 176,
				name: 'Бирюзовый/фиол. переливчатый',
				type: VehiclePaintType.Chameleon,
				hex: null,
				showInPaint: true,
				showInRims: false,
				showInBrakes: false,
			},
			{
				index: 177,
				name: 'Бирюзовый/красный переливчатый',
				type: VehiclePaintType.Chameleon,
				hex: null,
				showInPaint: true,
				showInRims: false,
				showInBrakes: false,
			},
			{
				index: 178,
				name: 'Бирюзовый/фиол. переливчатый',
				type: VehiclePaintType.Chameleon,
				hex: null,
				showInPaint: true,
				showInRims: false,
				showInBrakes: false,
			},
			{
				index: 179,
				name: 'Голубой/фиол. переливчатый',
				type: VehiclePaintType.Chameleon,
				hex: null,
				showInPaint: true,
				showInRims: false,
				showInBrakes: false,
			},
		];

		const pearlColors = paintColors.filter(
			(e) => e.type === VehiclePaintType.Pearl,
		);
		this.pearlColors.next(pearlColors);

		const indexedColors = paintColors.filter(
			(e) => e.type !== VehiclePaintType.Pearl,
		);
		this.indexedColors.next(indexedColors);

		const rimsColors = [
			{
				index: 0,
				name: 'Черный',
				type: VehiclePaintType.Pearl,
				hex: '#0d0d0d',
				showInPaint: false,
				showInRims: true,
				showInBrakes: false,
			},
			{
				index: 14,
				name: 'Красный Formula',
				type: VehiclePaintType.Pearl,
				hex: '#c40000',
				showInPaint: false,
				showInRims: true,
				showInBrakes: false,
			},
			{
				index: 15,
				name: 'Лавово-красный',
				type: VehiclePaintType.Pearl,
				hex: '#ff4500',
				showInPaint: false,
				showInRims: true,
				showInBrakes: false,
			},
			{
				index: 16,
				name: 'Огненно-красный',
				type: VehiclePaintType.Pearl,
				hex: '#ff1a1a',
				showInPaint: false,
				showInRims: true,
				showInBrakes: false,
			},
			{
				index: 17,
				name: 'Красный Grace',
				type: VehiclePaintType.Pearl,
				hex: '#d62d20',
				showInPaint: false,
				showInRims: true,
				showInBrakes: false,
			},
			{
				index: 18,
				name: 'Гранатовый',
				type: VehiclePaintType.Pearl,
				hex: '#722f37',
				showInPaint: false,
				showInRims: true,
				showInBrakes: false,
			},
			{
				index: 19,
				name: 'Закатно-красный',
				type: VehiclePaintType.Pearl,
				hex: '#ff6b4a',
				showInPaint: false,
				showInRims: true,
				showInBrakes: false,
			},
			{
				index: 20,
				name: 'Каберне',
				type: VehiclePaintType.Pearl,
				hex: '#4a0e1a',
				showInPaint: false,
				showInRims: true,
				showInBrakes: false,
			},
			{
				index: 21,
				name: 'Винно-красный',
				type: VehiclePaintType.Pearl,
				hex: '#722f37',
				showInPaint: false,
				showInRims: true,
				showInBrakes: false,
			},
			{
				index: 22,
				name: 'Яблочно-красный',
				type: VehiclePaintType.Pearl,
				hex: '#a52a2a',
				showInPaint: false,
				showInRims: true,
				showInBrakes: false,
			},
			{
				index: 23,
				name: 'Ярко-розовый',
				type: VehiclePaintType.Pearl,
				hex: '#ff1493',
				showInPaint: false,
				showInRims: true,
				showInBrakes: false,
			},
			{
				index: 24,
				name: 'Розовый Pfister',
				type: VehiclePaintType.Pearl,
				hex: '#ff69b4',
				showInPaint: false,
				showInRims: true,
				showInBrakes: false,
			},
			{
				index: 25,
				name: 'Лососево-розовый',
				type: VehiclePaintType.Pearl,
				hex: '#fa8072',
				showInPaint: false,
				showInRims: true,
				showInBrakes: false,
			},
		];
		this.rimsColors.next(rimsColors);

		this.brakesColors.next(this.brakesColorsData);

		// Rims
		this.rimsColorPrice.next(10_000);

		// Tints
		const paintWindowTints = [
			{ value: 0, name: 'Затемнение отсутствует', price: 0 },
			{ value: 3, name: 'Затемнение 25%', price: 1_000 },
			{ value: 2, name: 'Затемнение 50%', price: 10_000 },
			{ value: 1, name: 'Затемнение 90%', price: 100_000 },
		];
		this.windowTints.next(paintWindowTints);
	}

	public async getOwnedVehiclePaint(): Promise<IVehiclePaint> {
		return _.cloneDeep(this.ownedPaintStub);
	}

	public async restoreColors(): Promise<void> {
		console.log('vehiclePaintShop:restoreColors');
	}

	public async previewBodyColor(
		colorHexOrIndex: string | number,
		paintType: VehiclePaintType,
		pearlColorIndex: number | null,
	): Promise<void> {
		console.log('vehiclePaintShop:previewBodyColor', {
			colorHexOrIndex,
			paintType,
			pearlColorIndex,
		});
	}

	public async previewInteriorColor(colorHex: string): Promise<void> {
		console.log('vehiclePaintShop:previewInteriorColor', {
			colorHex,
		});
	}

	public async previewBrakesColor(colorIndex: number): Promise<void> {
		console.log('vehiclePaintShop:previewBrakesColor', {
			color: colorIndex,
		});
	}

	public async previewRimsColor(colorIndex: number | null): Promise<void> {
		console.log('vehiclePaintShop:previewRimsColor', { color: colorIndex });
	}

	public async previewWindowTint(tintValue: number | null): Promise<void> {
		console.log('vehiclePaintShop:previewWindowTint', { tint: tintValue });
	}

	public async buy(paint: Partial<IVehiclePaint>): Promise<void> {
		const updatedOwnedPaint = _.merge(this.ownedPaintStub, paint);

		console.log(
			'vehiclesPaint:buy',
			{ paintToBuy: paint },
			{ ownedPaint: this.ownedPaintStub },
			{ updatedOwnedPaint },
		);

		this.ownedPaintStub = updatedOwnedPaint;
	}

	public async exit(): Promise<void> {
		console.log('vehiclePaintShop:exit');
	}
}
